import { Router } from '@angular/router';
import { CardholderDetails } from './../../data/CardholderDetails';
import { MessageService } from 'src/app/services/message.service';
import { CardholderUserService } from './../../services/cardholder-user.service';
import { EntitlementService } from './../../services/entitlement.service';
import { Component, OnInit } from '@angular/core';
import { CustomerAccount } from 'src/app/data/CustomerAccount';
import {CardholderService} from "../../services/cardholder.service";
import {ProfileSearchResult} from "../../data/ProfileSearchResult";

@Component({
  selector: 'app-cardholder-account-details',
  templateUrl: './cardholder-account-details.component.html',
  styleUrls: ['./cardholder-account-details.component.css']
})
export class CardholderAccountDetailsComponent implements OnInit {
  constructor(
    private entitlementService: EntitlementService,
    private cardholderUserService: CardholderUserService,
    private messageService: MessageService,
    private router: Router
  ) {}

  cardholderDetails: CardholderDetails;
  selectedChipAccount: CustomerAccount;
  stripAccount: CustomerAccount;
  fullName = '';
  cardholder: ProfileSearchResult;

  ngOnInit() {
    this.getCardholderAccountDetails();
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  getCardholderAccountDetails() {
    const chipAccounts: CustomerAccount[] = [];
    this.cardholder = CardholderService.retrieveCardholder();
    //CardholderService.storeCardHolder(null);
    if(this.cardholder != null) {
      this.cardholderUserService.getCardholderDetails(this.cardholder.cardNum).subscribe(
        data => {
          this.cardholderDetails = data;
          const identity = this.cardholderDetails.identity;
          this.fullName =
            identity.firstName +
            ' ' +
            (identity.middleName === null ? '' : identity.middleName) +
            ' ' +
            identity.lastName;
          this.cardholderDetails.customerAccounts.forEach(element => {
            if (element.type === 'PAYROLL') {
              this.stripAccount = element;
            } else {
              chipAccounts.push(element);
            }
          });

          this.selectedChipAccount = chipAccounts[0];
        },
        error => {
          this.messageService.error(error.error);
        },
        () => {
          //CardholderService.storeCardHolder(null);
        }
      );
    }
    else {
      this.cardholderUserService.getCardholderDetails().subscribe(
        data => {
          this.cardholderDetails = data;
          const identity = this.cardholderDetails.identity;
          this.fullName =
            identity.firstName +
            ' ' +
            (identity.middleName === null ? '' : identity.middleName) +
            ' ' +
            identity.lastName;
          this.cardholderDetails.customerAccounts.forEach(element => {
            if (element.type === 'PAYROLL') {
              this.stripAccount = element;
            } else {
              chipAccounts.push(element);
            }
          });

          this.selectedChipAccount = chipAccounts[0];
        },
        error => {
          this.messageService.error(error.error);
        }
      );
    }
  }
}
